import DetectBreakpoints from '~utilities/detect-breakpoints';

class Campagne {
    constructor(element) {
      this.element = element;

      this.text = this.element.querySelector('[js-campagne-text]');
      this.items = [...this.element.querySelectorAll('[js-campagne-item]')];

      if(this.items.length == 2) {
        this.setPositions();

        addEventListener("resize", (event) => {
          this.setPositions();
        });
      }
    }

    setPositions() {
      const firstElementHeight = this.items[0].clientHeight;
      const secondElementHeight = this.items[1].clientHeight;
      const textElementHeight = this.text.clientHeight;
      const offset = 104;

      if(firstElementHeight < textElementHeight) {
        this.items[1].style.marginTop = `${firstElementHeight - textElementHeight}px`;
      } else if(Math.abs(textElementHeight - firstElementHeight) > (secondElementHeight - offset)) {
        this.items[1].style.marginTop = `-${secondElementHeight - offset}px`;
        this.text.style.transform = `translate3d(0px, ${((firstElementHeight - (secondElementHeight - offset) - textElementHeight) / 2)}px, 0px)`;
      } else {
        this.items[1].style.marginTop = `${textElementHeight - firstElementHeight}px`;
      }

      let envs = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
      const minBreakpoint = envs.indexOf('md');
      const breakpoint = envs.indexOf(DetectBreakpoints.breakpoint);
      
      if(breakpoint < minBreakpoint) {
        this.items[1].style.marginTop = `0px`;
        this.text.style.transform = `translate3d(0px, 0px, 0px)`;
      }
    }
}

export default Campagne;